<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="添加时间">
          <date-range-picker :value="addTime" @getChange="value => addTime = value"/>
        </el-form-item>
        <el-form-item label="银行编号">
          <el-input v-model="searchForm.bankCode" placeholder="请输入银行编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-autocomplete
          v-model="searchForm.bankName"
          :fetch-suggestions="querySearch"
          placeholder="请输入银行名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="银行经理工号">
          <el-input v-model="searchForm.managerNo" placeholder="请输入银行经理工号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行经理姓名">
          <el-input v-model="searchForm.name" placeholder="请输入银行经理姓名" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行经理手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入银行经理手机号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行经理编号">
          <el-input v-model="searchForm.managerId" placeholder="请输入银行经理编号" :clearable="true"/>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button type="default" :loading="exportLoading" @click="handleExport">导出</el-button>
      </el-form>
    </module-card>

    <module-card title="银行经理管理">
      <auth-button opt="addManager" icon="el-icon-plus" label="新增银行经理" class="editBtn" @click.native="handleAddManager">新增银行
      </auth-button>
      <batch-import
        class="batchImport"
        button-text="批量新增"
        submit-name="batchAddManager"
        :templateName="batchAddTemplateName"
        dialog-title="批量添加银行经理"
        fail-key="failMerchants"
        @submit="importSubmit"
        :tableList="[
          { label: '银行经理姓名', prop: 'managerName' },
          { label: '银行经理手机号码', prop: 'managerPhone' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"/>
      <el-table class="table" border :data="list" v-loading="tableLoading">
        <el-table-column
          label="创建时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="银行经理工号"
          prop="managerNo">
        </el-table-column>
        <el-table-column
          label="银行经理编号"
          prop="managerId">
        </el-table-column>
        <el-table-column
          label="银行经理姓名"
          prop="name">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="phone">
        </el-table-column>
        <el-table-column
          label="所属银行编号"
          prop="bankCode">
        </el-table-column>
        <el-table-column
          label="所属银行名称"
          prop="bankName">
        </el-table-column>
        <el-table-column
          label="开卡二维码"
          prop="bankName">
          <template slot-scope="scope">
            <div>
             <auth-button auth-type="span" opt="downloadCode" label="下载开卡码" class="editBtn" @click.native="downloadCode(scope.row)"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" prop="freezeStatus">
          <template slot-scope="scope">
            {{scope.row.freezeStatus === 1 ? '已冻结' : '正常' }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="最近操作人"
          prop="operator">
          <template slot-scope="scope">
            {{ scope.row.operator ? scope.row.operator : "-"}}
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime">
        </el-table-column> -->
        <el-table-column
          width="260"
          label="操作">
          <template slot-scope="scope">
            <div class="flex-space-around">
               <auth-button auth-type="span" opt="editManager" label="操作记录" class="editBtn"
                           @click.native="viewOperateRecords(scope.row)"/>
              <auth-button auth-type="span" opt="editManager" label="编辑" class="editBtn"
                           @click.native="handleEditManager(scope.row)"/>
              <auth-button auth-type="span" opt="viewManager" label="查看详情" class="editBtn"
                           @click.native="handleViewManager(scope.row, 'Relate')"/>
              <!-- <auth-button auth-type="span" opt="deleteManager" label="删除" class="editBtn"
                           @click.native="handleDeleteManager(scope.row)"/> -->
              <auth-button auth-type="span" opt="deleteManager" :label="parseInt(scope.row.freezeStatus)===1?'解冻':'冻结'" class="editBtn"
                           @click.native="handleFreezeManager(scope.row)"/>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize"
                  @changePage="value => { this.pageNo = value; getList() }"/>
    </module-card>
    <dialog-info
      :visible.sync="showManagerDialog"
      :title="dialogTypeName + '银行经理'"
      @confirm="submitManager"
      @close="clearBankInfo"
      :comfirmLoading="addManagerLoading"
      size="large"
      footerAlign="center">
      <el-form ref="managerForm" :model="managerForm" :rules="filterRuleData" label-width="120px" label-position="left">
        <el-form-item prop="name" label="银行经理姓名">
          <el-input v-model="managerForm.name" placeholder="请输入银行经理姓名" class="form-input" :disabled="dialogType===3"/>
        </el-form-item>
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="managerForm.phone" placeholder="请输入银行经理手机号" class="form-input" :disabled="dialogType===3"/>
        </el-form-item>
        <el-form-item prop="managerNo" label="银行经理工号">
          <el-input v-model="managerForm.managerNo" placeholder="请输入银行经理工号" class="form-input" :disabled="dialogType===3"/>
        </el-form-item>
         <el-form-item prop="email" label="邮箱">
          <el-input v-model="managerForm.email" placeholder="请输入银行经理邮箱" class="form-input" :disabled="dialogType===3"/>
        </el-form-item>
        <el-form-item v-if="$store.state.userInfo.userType !== 4" prop="bankType" label="所属银行类型">
          <el-select v-model="managerForm.bankType" placeholder="请选择银行类型" :disabled="dialogType===3" @change="selectBankType">
            <el-option v-for="item in bankTypeList" :key="item.value" :value="item.value"
                       :label="item.label"/>
          </el-select>
        </el-form-item>
        <el-form-item v-if="$store.state.userInfo.userType !== 4" prop="bankCode" label="所属银行名称">
          <el-select v-model="managerForm.bankCode" placeholder="请选择银行类型" :disabled="dialogType===3" @change="selectBankCode" filterable>
           <el-option v-for="item in bankList" :key="item.newCode" :value="item.newCode"
                       :label="item.name"/>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="managerId" label="银行经理编号">
          <el-input v-model="managerForm.managerId" placeholder="请输入银行经理编号" class="form-input" disabled/>
        </el-form-item> -->
      </el-form>
    </dialog-info>
    <!-- 开卡码弹窗 -->
    <el-dialog
        :visible.sync="openCardDialog"
        custom-class="openCard-dialog"
        @close="dialogFrom = {}"
        width="250px"
         style="text-align: center">
        <el-row>
          <el-col :span="11">
            <div>{{ dialogFrom.name }}</div>
          </el-col>
          <el-col :span="13">
            <div>{{ dialogFrom.phone }}</div>
          </el-col>
        </el-row>
        <el-row style="margin: 10px 0;">
          <el-col>
            <div>{{ dialogFrom.bankCode }}</div>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px; left: 50%; margin-left: -50px">
          <el-col>
            <div id="qrcode" ref="qrCodeUrl"></div>
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-col>
            <div>{{ dialogFrom.bankName }}</div>
          </el-col>
        </el-row>
    </el-dialog>
    <!-- 操作记录查询对话框 -->
    <dialog-info
      :visible.sync="showOperateLogDialog"
      title="操作记录"
      size="middle"
      :showCancelBtn="false"
      footerAlign="center"
      confirmText="关闭"
      @confirm="showOperateLogDialog=false"
    >
      <el-table border :data="operateRecordsPageData" v-loading="recordsLoading">
        <el-table-column label="更新时间" prop="createTime"></el-table-column>
        <el-table-column label="操作内容" prop="operationContent"></el-table-column>
        <el-table-column label="操作人" prop="operatorId"></el-table-column>
      </el-table>
      <pagination :count="recordsPagination.total" :page-no="recordsPagination.pageNo" :size="recordsPagination.pageSize"
                  @changePage="value => { this.recordsPagination.pageNo = value; setRecordsDataByPage() }"/>
    </dialog-info>
  </div>
</template>
<script>
import dialogInfo from '@/components/layout/dialogInfo'
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import batchImport from '@/components/upload/batchImport'
import { downJumpConfirm, deepClone } from '@/assets/js/utils'
import QRCode from 'qrcodejs2'

export default {
  name: 'bankManage',
  components: {
    dialogInfo,
    pagination,
    dateRangePicker,
    batchImport
  },
  data () {
    return {
      dialogFrom: {},
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableLoading: false,
      addManagerLoading: false,
      showManagerDialog: false,
      openCardDialog: false,
      showOperateLogDialog: false,
      operationRecordsData: [],
      qrcode: null,
      dialogType: 1,
      managerForm: {
        bankType: '',
        managerNo: '',
        name: '',
        phone: '',
        email: '',
        bankCode: ''
      },
      ruleData: {
        bankType: [{
          required: true,
          message: '请选择银行类型',
          trigger: 'blur'
        }],
        bankCode: [{
          required: true,
          message: '请输入银行名称',
          trigger: 'blur'
        }],
        managerNo: [{
          required: true,
          message: '请输入银行经理工号',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入银行经理姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入银行经理手机',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入银行经理邮箱',
          trigger: 'blur'
        }]
      },
      bankTypeList: [
        { value: 1, label: '总行' },
        { value: 2, label: '分行' },
        { value: 3, label: '支行' }
      ],
      bankList: [],
      bankTypeListHashMap: {
        1: '总行',
        2: '分行',
        3: '支行'
      },
      searchForm: {
        bankCode: '',
        bankName: '',
        addTimeStart: '',
        addTimeEnd: '',
        managerNo: '',
        name: '',
        phone: '',
        managerId: ''
      },
      exportLoading: false,
      searchLoading: false,
      addTime: [],
      recordsLoading: false,
      operateRecordsPageData: [],
      recordsPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    filterRuleData () {
      const copyData = deepClone(this.ruleData)
      if (this.dialogType === 1) {
        copyData.phone.push({
          pattern: /^\d{11,11}$/,
          message: '请输入正确手机格式'
        })
      } else {
        copyData.phone[0].required = false
      }
      copyData.email.push({
        pattern: /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/,
        // pattern: /^\d{11,11}$/,
        message: '请输入正确邮箱格式'
      })
      return copyData
    },
    batchAddTemplateName () {
      return this.$store.state.userInfo.userType === 4 ? '【银行】批量新增银行经理' : '【运营】批量新增银行经理模板'
    },
    dialogTypeName () {
      let name = ''
      switch (this.dialogType) {
        case 1:
          name = '新增'
          break
        case 2:
          name = '编辑'
          break
        case 3:
          name = '查看'
          break
      }
      return name
    }
  },
  methods: {
    async init () {
      this.getList()
    },
    formatBankType (row) {
      const { bankType } = row
      return this.bankTypeListHashMap[bankType] || '未知类型'
    },
    selectBankType (bankType) {
      console.log(bankType)
      this.managerForm.bankCode = ''
      this.getBankList(bankType)
    },
    getBankList (bankType) {
      this.$axios.post(this.$api.bankList, { bankType }).then(res => {
        console.log(res)
        if (res.respCode === '0') {
          this.bankList = res.data.list
        }
      })
    },
    selectBankCode (bankCode) {
      this.managerForm.bankCode = bankCode
    },
    getList () {
      this.tableLoading = true
      this.searchLoading = true
      this.searchForm.addTimeStart = this.addTime[0] || ''
      this.searchForm.addTimeEnd = this.addTime[1] || ''
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.$axios.post(this.$api.managerPageList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.tableLoading = false
        this.searchLoading = false
      })
    },
    handleAddManager () {
      this.showManagerDialog = true
      this.bankList = []
      this.dialogType = 1
    },
    handleEditManager (row) {
      this.dialogType = 2
      Object.keys(row).forEach(key => {
        row[key] && (this.managerForm[key] = row[key])
      })
      this.$nextTick(() => {
        this.showManagerDialog = true
        this.getBankList(row.bankType)
      })
    },
    handleViewManager (row) {
      this.dialogType = 3
      Object.keys(row).forEach(key => {
        row[key] && (this.managerForm[key] = row[key])
      })
      this.$nextTick(() => {
        this.showManagerDialog = true
      })
    },
    handleExport () {
      this.exportLoading = true
      this.$axios.post(this.$api.exportManager, this.searchForm).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    submitManager () {
      if (this.dialogType === 3) {
        this.showManagerDialog = false
        return
      }
      let managerValid = true
      this.$refs.managerForm.validate((valid) => {
        if (!valid) {
          managerValid = false
        }
      })
      if (!managerValid) {
        this.$message({
          type: 'warning',
          message: '请完善信息后提交！'
        })
      } else {
        let api
        let message
        this.addManagerLoading = true
        if (this.dialogType === 1) {
          api = 'addManager'
          message = '新增成功！'
        } else if (this.dialogType === 2) {
          api = 'editManager'
          message = '编辑成功'
        }
        this.$axios.post(this.$api[api], this.managerForm).then(res => {
          if (res.respCode === '0') {
            this.addManagerLoading = false
            this.showManagerDialog = false
            this.$message({
              type: 'success',
              message: message
            })
            this.getList()
          }
        })
      }
    },
    clearBankInfo () {
      this.showManagerDialog = false
      this.managerForm = this.$options.data().managerForm
      this.$nextTick(() => {
        this.$refs.managerForm.clearValidate()
        // this.$refs.form0[0].clearValidate()
      })
    },
    handleDeleteManager (row) {
      this.$confirm('是否确认删除该银行经理', '温馨提示').then(res => {
        this.$axios.get(this.$api.deleteManager, {
          params: {
            id: row.id
          }
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              showClose: 'true',
              message: '删除成功'
            })
            this.getList()
          }
        })
      })
    },
    doFreezeManager (id, status) {
      const params = { id, freezeStatus: status === 1 ? 0 : 1 }
      this.$axios.post(this.$api.updateMangerStatus, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getList()
        }
      })
    },
    handleFreezeManager (row) {
      const content = row.freezeStatus === 1 ? '是否解冻银行经理：' + row.name + '的账号？解冻后可正常登录小程序' : '是否冻结银行经理：' + row.name + '的账号？冻结后无法登录小程序'
      const title = row.freezeStatus === 1 ? '解冻确认' : '冻结确认'
      this.$confirm(content, title, { type: 'warning' }).then(() => {
        this.doFreezeManager(row.id, row.freezeStatus)
      })
    },
    viewOperateRecords (row) {
      this.showOperateLogDialog = true
      this.recordsPagination.pageNo = 1
      this.recordsPagination.pageSize = 10
      const params = { bankCode: row.managerId }
      this.recordsLoading = true
      this.$axios.post(this.$api.operationRecords, params).then(res => {
        this.recordsLoading = false
        if (res.respCode === '0') {
          this.operationRecordsData = res.data
          this.recordsPagination.total = res.data.length || 0
          this.setRecordsDataByPage()
        } else {
          this.operationRecordsData = []
          this.operateRecordsPageData = []
          this.recordsPagination.total = 0
        }
      }).catch(() => {
        this.recordsLoading = false
        this.operateRecordsPageData = []
        this.operationRecordsData = []
        this.recordsPagination.total = 0
      })
    },
    setRecordsDataByPage () { // 操作记录前端分页
      const begin = (this.recordsPagination.pageNo - 1) * this.recordsPagination.pageSize
      const end = this.recordsPagination.pageSize * this.recordsPagination.pageNo
      this.operateRecordsPageData = this.operationRecordsData.slice(begin, end)
    },
    search () {
      // this.pagination
      this.pageNo = 1
      this.getList()
    },
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    },
    // 下载开卡码
    downloadCode (row) {
      console.log(row)
      this.dialogFrom = row
      this.openCardDialog = true
      this.$nextTick(() => {
        if (this.qrcode !== null) {
          document.getElementById('qrcode').innerHTML = ''
        }
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: JSON.stringify({ name: row.name, phone: row.phone, managerId: row.managerId, bankCode: row.bankCode, bankName: row.bankName }), // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.bankFuzzySearch, {
            bankName: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data.list
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    }
  }
}
</script>
<style scoped lang="less">
  .table {
    margin-top: 20px;
  }

  .form-flex-item {
    margin-right: 5px;
  }

  .icon {
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: #409EFF;
    color: #fff;
    margin-left: 12px;
    cursor: pointer;
    user-select: none; /* Standard syntax */
  }

  .form-input {
    width: 610px;
  }

  .inner-input {
    width: 230px;
  }

  /deep/.openCard-dialog{
    .el-dialog__header {
      display: none;
      height: 30px;
    }
    .el-dialog__body {
      padding: 20px;
    }
  }
</style>
